import FileReference from '@kaizenplatform/belfast-entity/dist/entity/FileReference';
import { useCallback, useContext, useEffect, useState } from 'react';

import { GetProjectByIdQuery } from '../graphql/generated/graphql';
import { context as DependencyContext } from '../view/context/dependency';
import { context as StateContext } from '../view/context/state';

export const useGetProjectQuery = (creationSetId: string | undefined) => {
  const dependency = useContext(DependencyContext);
  const state = useContext(StateContext);

  const [res, setRes] = useState<NonNullable<GetProjectByIdQuery['project']>>();
  const [briefFiles, setBriefFiles] = useState<Map<string, FileReference[]>>(new Map());
  const [assetFiles, setAssetFiles] = useState<FileReference[]>([]);
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(
    async (creationSetId: string) => {
      setLoading((loading) => ++loading);
      const res = await dependency.projectWebApi.getByCreationSetId(creationSetId, state.language);
      const { briefFiles, assetFiles } = await dependency.showProjectUsecase.getFiles(res);
      setRes(res);
      setBriefFiles(briefFiles);
      setAssetFiles(assetFiles);
      setLoading((loading) => --loading);
    },
    [dependency.projectWebApi, dependency.showProjectUsecase, state.language],
  );

  useEffect(() => {
    if (creationSetId) {
      fetchData(creationSetId);
    }
  }, [fetchData, creationSetId]);

  return { project: res, briefFiles, assetFiles, loading: loading > 0 };
};
